export const mockGames = [
  {
    id: 570,
    name: "Dota 2",
    playerCount: 625000,
    peakToday: 750000,
    peakAllTime: 1295000,
    categories: ["MOBA", "Strategy", "Competitive"],
    imageUrl: "https://cdn.cloudflare.steamstatic.com/steam/apps/570/header.jpg",
    description: "Every day, millions of players worldwide enter battle as one of over a hundred Dota heroes. And no matter if it's their 10th hour of play or 1,000th, there's always something new to discover.",
    releaseDate: "July 9, 2013",
    developer: "Valve",
    publisher: "Valve"
  },
  {
    id: 730,
    name: "Counter-Strike 2",
    playerCount: 1150000,
    peakToday: 1350000,
    peakAllTime: 1802000,
    categories: ["FPS", "Shooter", "Competitive"],
    imageUrl: "https://cdn.cloudflare.steamstatic.com/steam/apps/730/header.jpg",
    description: "Counter-Strike 2 expands upon the team-based action gameplay that it pioneered when it was launched 20 years ago.",
    releaseDate: "September 27, 2023",
    developer: "Valve",
    publisher: "Valve"
  },
  {
    id: 578080,
    name: "PUBG: BATTLEGROUNDS",
    playerCount: 350000,
    peakToday: 460000,
    peakAllTime: 3257248,
    categories: ["Battle Royale", "Shooter", "Survival"],
    imageUrl: "https://cdn.cloudflare.steamstatic.com/steam/apps/578080/header.jpg",
    description: "Play PUBG: BATTLEGROUNDS for free. Land on strategic locations, loot weapons and supplies, and survive to become the last team standing across various, diverse Battlegrounds.",
    releaseDate: "December 21, 2017",
    developer: "KRAFTON, Inc.",
    publisher: "KRAFTON, Inc."
  }
];